class Api {
  _init = async () => {
    tizen.tvwindow.hide(() => {}, null, "MAIN")
    //document.getElementById("viewport").setAttribute("content", "width=1280, initial-scale=1.5")

    //await this.loadResources()
    await _$.sleep(2000)
    await this.makeConfigurations()

    this.addListeners()
    return true
  }

  addListeners = () => {
    document.addEventListener("visibilitychange", _$.handler.emit, false)
    const listener = {
      onbufferingcomplete: () => _$.handler.emit("media_event", "play"),
      onevent: eventType => eventType === "PLAYER_MSG_RENDER_DONE" && _$.handler.emit("media_event", "play"),
      onstreamcompleted: () => _$.handler.emit("media_event", "ended"),
      onerror: () => _$.handler.emit("media_event", "error")
    }
    webapis.avplay.setListener(listener)

    _$.vue.$on("mediaPlaying", () => !__.device.isPowerOn() && __.media.stop().then(() => __.media.request(true)))

    _$.vue.$on("standBy", () => __.platform.go().then(() => __.media.request(true)))
    _$.vue.$on("powerOn", () => __.media.request())

    return true
  }
  makeConfigurations = async () => {
    webapis.avplay._setDisplayRects(0, 0, 1920, 1080, false)
    tizen.tvwindow.hide(() => {}, null, "MAIN")

    const powerListener = e => {
      if (e.event === "POWER_STATUS_CHANGE" && e.data !== "Normal") _$.handler.emit("power_mode_changed", "standby")
      else _$.handler.emit("power_mode_changed", "on")
    }

    try {
      b2bapis.b2bpower.setPowerStateChangeListener(powerListener)
    } catch (e) {
      b2bapis.b2bpower.unsetPowerStateChangeListener(powerListener)
      b2bapis.b2bpower.setPowerStateChangeListener(powerListener)
    }

    b2bapis.b2bcontrol.setForwardMessageListener(e => _$.handler.emit("data_received", e))

    return true
  }
  loadResources = async () => {}
  checkOut() {
    _$.sleep(3000).then(() => __.device.reboot())
  }
}

export default Api
